import { render, staticRenderFns } from "./Class.vue?vue&type=template&id=00e5bd12&"
import script from "./Class.vue?vue&type=script&lang=js&"
export * from "./Class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports